import DefaultTable from '../DefaultTable/DefaultClass'

class CurrencyRates extends DefaultTable {
    constructor(props) {
        super(props)

        this.filters_top = [
            {
                name: 'currency',
                type: "ReferenceInput",
                alwaysOn: true,
                parameters: {reference: 'Currencies', optionText: 'name', locale: true},
            }
        ]

        this.filters_aside = []
        this.filters_aside = [...this.default_filters_aside, ...this.filters_aside]

        this.fields_data = [
            {
                tab: "COMMON",
                dataTab: [
                    {
                        box: [
                            {
                                name: 'currency',
                                type: 'text',
                                show_type: 'ReferenceField',
                                edit_type: 'ReferenceInput',
                                type_ext: {reference: 'Currencies', optionText: 'name', locale: true},
                                read_only: false,
                                flex: 2,
                            },
                            {
                                name: 'rate',
                                type: 'float',
                                show_type: 'NumberField',
                                // show_type: 'EditFieldFromList',
                                // type_ext: {width: "100px"},
                                edit_type: 'NumberInputFloatComp',
                                read_only: false,
                                flex: 1,
                            },
                        ]
                    },
                ]
            },
        ]
        this.fields_data = [...this.default_fields_data, ...this.fields_data]

    }
}

export default CurrencyRates